import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  cropTypesApi,
  type CreateCropTypeRequest,
  type UpdateCropTypeRequest,
  type CropTypeListQuery,
} from "../services/cropTypesApi";

export const useActiveCropTypes = () => {
  return useQuery({
    queryKey: ["cropTypes", "active"],
    queryFn: cropTypesApi.getActiveCropTypes,
  });
};

export const useAllCropTypes = (enabled = true) => {
  return useQuery({
    enabled,
    queryKey: ["cropTypes"],
    queryFn: cropTypesApi.getAllCropTypes,
  });
};

export const useCropTypesPaged = (query: CropTypeListQuery = {}) => {
  return useQuery({
    queryKey: ["cropTypes", "paged", query],
    queryFn: () => cropTypesApi.getCropTypesPaged(query),
    placeholderData: keepPreviousData,
  });
};

export const useCropTypeById = (id: string) => {
  return useQuery({
    queryKey: ["cropTypes", id],
    queryFn: () => cropTypesApi.getCropTypeById(id),
    enabled: !!id,
  });
};

export const useCreateCropType = () => {
  return useMutation({
    mutationFn: (payload: CreateCropTypeRequest) =>
      cropTypesApi.createCropType(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cropTypes"] });
      queryClient.invalidateQueries({ queryKey: ["cropTypes", "active"] });
    },
  });
};

export const useUpdateCropType = () => {
  return useMutation({
    mutationFn: (payload: UpdateCropTypeRequest) =>
      cropTypesApi.updateCropType(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["cropTypes"] });
      queryClient.invalidateQueries({ queryKey: ["cropTypes", data.id] });
      queryClient.invalidateQueries({ queryKey: ["cropTypes", "active"] });
    },
  });
};

export const useDeleteCropType = () => {
  return useMutation({
    mutationFn: (id: string) => cropTypesApi.deleteCropType(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cropTypes"] });
      queryClient.invalidateQueries({ queryKey: ["cropTypes", "active"] });
    },
  });
};